// this classList manipulation should be done in componentWillUpdate
// currently, the DOM manipulation will occur regardless of success/timing of API response
export function flashDraggableItem(_el) {
  setTimeout(() => {
    _el.classList.add('flash')
    setTimeout(() => {
      _el.classList.remove('flash')
    }, 500)
  }, 500)
}



// WEBPACK FOOTER //
// ./src/utils/draggableitem.js